import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { TipoDesconexion, Posicion } from './solucion.entity';
import { NavegacionService } from '../sidenav.service';
import { Respuesta, Pregunta, RespuestaTipoOpciones } from '../cuestionario/cuestionario.entity';
import { Etapa, Desconexion } from '../diagnostico/Diagnostico.entity';
import { CuestionarioHttpServicesService } from '../cuestionario-http-services.service';
import { Dimension } from './Dimension.entity';
import { Capa } from './Capa.entity';
import {trigger, state, style, animate, transition, group} from '@angular/animations';
import { LoaderService } from '../loader.service';
import { User } from '../shared/user.model';
import { UserService } from '../shared/user.service';
import { MatDialogRef, MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { SolucionDocumentComponent } from '../solucion-document/solucion-document.component';
import { TarjetacompletaComponent } from '../tarjetacompleta/tarjetacompleta.component';


@Component({
  selector: 'app-solucion',
  templateUrl: './solucion.component.html',
  styleUrls: ['./solucion.component.css'], // , '../../assets/scss/tool-styles.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('1000ms ease-in', style({transform: 'translateX(0%)'}))
      ]),
      transition(':leave', [
        animate('1000ms ease-in', style({transform: 'translateX(-100%)'}))
      ])
    ]),
    trigger('flyInOut', [
      state('in', style({transform: 'scale(1.1)'})),
      transition('void => *', [
        style({transform: 'scale(0)'}),
        animate(3000)
      ]),
      transition('* => void', [
        animate(3000, style({transform: 'scale(1.1)'}))
      ])
    ])
    ,
    trigger('flyInOut2', [
      state('in', style({transform: 'translateX(0)'})),
      transition('void => *', [
        style({transform: 'translateX(-100%)'}),
        animate(2000)
      ]),
      transition('* => void', [
        animate(2000, style({transform: 'translateX(100%)'}))
      ])
    ])
  ]
})

export class SolucionComponent implements OnInit {
  @ViewChild('pdfwrapper') pdfwrapper: ElementRef;
  public error = false;
  public errorMessage = '';
  public _posicionesCentro: Posicion[] = [{top: 250, left: 250},
    {top: 280, left: 230}, {top: 250, left: 340}, {top: 280, left: 360},
    {top: 340, left: 360}, {top: 360, left: 320}, {top: 360, left: 250},
    {top: 340, left: 230}, {top: 260, left: 300}, {top: 370, left: 300}];
  public _posicionesAroExterior: Posicion[] = [{top: -60, left: 300},
      {top: 0, left: 500}, {top: 180, left: 630}, {top: 300, left: 655},
      {top: 420, left: 630}, {top: 580, left: 520}, {top: 655, left: 300},
      {top: 580, left: 80},  {top: 420, left: -40}, {top: 300, left: -60},
      {top: 180, left: -40},  {top: 0, left: 0} ];
       // Indice del 6 al 11
  public _posicionSuperior: Posicion[] = [{top: 130, left: 250}, {top: 210, left: 250 }, // Interior
        {top: 130, left: 340}, {top: 130, left: 380},
        {top: 220, left: 360}, {top: 220, left: 320},
        {top: 60, left: 380}, {top: 80, left: 230}, {top: 60, left: 250}, // Exterior
        {top: 210, left: 340}]; // Interior
        // Indice del 12 al 17
  public _posicionDerecha: Posicion[] = [{top: 250, left: 450},
          {top: 250, left: 550},
          {top: 250, left: 420}, {top: 380, left: 450}, {top: 340, left: 420}, // Interior
          {top: 340, left: 550}, {top: 220, left: 500}, {top: 380, left: 550}, // Exterior
          {top: 210, left: 550}, {top: 210, left: 550}];
          // Indice del 24 al 29
  public _posicionInferior: Posicion[] = [{top: 540, left: 230}, {top: 580, left: 250},
          {top: 480, left: 420}, {top: 420, left: 360}, {top: 420, left: 380},
          {top: 480, left: 340}, {top: 420, left: 200}, {top: 520, left: 230}, // Interior
          {top: 580, left: 380} , {top: 580, left: 340}]; // Exterior
          // Indice del 18 al 23
  public _posicionIzquierda: Posicion[] = [{top: 250, left: 80}, // Exterior
            {top: 250, left: 120}, {top: 250, left: 180}, {top: 340, left: 200}, // Interior
            {top: 340, left: 180}, {top: 340, left: 200}, {top: 380, left: 200},
            {top: 380, left: 80},
            {top: 210, left: 40}, {top: 210, left: 80}]; // Exterior
  public _etapas: Etapa[];
  public _respuestas: Respuesta[];
  public _preguntas: Pregunta[];
  public _respuestatipoopciones: RespuestaTipoOpciones[];
  public _capa: Capa[];
  public currentEtapa: Etapa = null;
  public item = 99;
  public itemDesco = 99;
  public _desconexiones: TipoDesconexion[] = [];
  public _dimensiones: Dimension[];
  isIzquierdoDisconnected = false;
  isDerechoDisconnected = false;
  isSuperiorDisconnected = false;
  isInferiorDisconnected = false;
  isCenterDisconnected = false;
  isfirstDisconnected = false;
  issecondDisconnected = false;
  isthirdDisconnected = false;
  isfourthDisconnected = false;
  isfifthDisconnected = false;
  issixthDisconnected = false;
  isseventhDisconnected = false;
  iseighthDisconnected = false;
  isleadershipDisconnected = false;
  currentClient: User = null;
  isShowlikedisabled = false;
  constructor( public _sidenav: NavegacionService,
    private _cuestionarioServices: CuestionarioHttpServicesService,
    private loaderService: LoaderService,
    public userService: UserService ,
    public dialog: MatDialog ) { }
  ngOnInit() {
     // alert('');
     this.loaderService.display(true);
     this.currentClient = this._sidenav.currentClient;
     // this.userService.getUserClaims().subscribe((data: any) => {
     //  this.currentClient = data;
     // console.log('En el init de solucion:' , this.currentClient);
      // this._sidenav.recursos(false);
      this._cuestionarioServices.getEtapa().subscribe( objEtapa => {
      this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe( objRespuestas => {
      this._cuestionarioServices.getPreguntas().subscribe( objPreguntas => {
      this._cuestionarioServices.getRespuestaTipoOpciones().subscribe( objRtop => {
      this._cuestionarioServices.getDimension().subscribe( objDim => {
      this._cuestionarioServices.getCapas().subscribe( objCapa => {
                this._capa   = objCapa;
                this._respuestas = objRespuestas;
                this._etapas = objEtapa;
                this._preguntas = objPreguntas;
                this._respuestatipoopciones = objRtop;
                this._dimensiones = objDim;
                this.currentEtapa = this._etapas.filter(x => x.descripcion === 'DESCONEXIONES')[0];
                this.CalcularDesconexiones();
                this.isShowlikedisabled = true;
                this.loaderService.display(false);
                // const element: HTMLElement = document.getElementById('switcher') as HTMLElement;
                // element.click();
          }, err => {this.errorMessage = err.message; this.error = true; } );
        }, err => {this.errorMessage = err.message; this.error = true; } );
       }, err => {this.errorMessage = err.message; this.error = true; } );
      }, err => {this.errorMessage = err.message; this.error = true; } );
     }, err => {this.errorMessage = err.message; this.error = true; } );
    // }, err => {this.errorMessage = err.message; this.error = true; } );
  });
  }
  CalcularDesconexiones() {
    // Recorrer el cuestionario y buscar por capa segun la cantidad mayor de repeticiones
    // Mostrar Desonexiones.
    // const etapaDimension = this._etapas.find(etapa => etapa.descripcion === 'Dimension');
    this._desconexiones = [];
    this.isIzquierdoDisconnected = false;
    this.isDerechoDisconnected = false;
    this.isSuperiorDisconnected = false;
    this.isInferiorDisconnected = false;
    this.isfirstDisconnected = false;
    this.issecondDisconnected = false;
    this.isthirdDisconnected = false;
    this.isfourthDisconnected = false;
    this.isfifthDisconnected = false;
    this.issixthDisconnected = false;
    this.isseventhDisconnected = false;
    this.iseighthDisconnected = false;
    this.isleadershipDisconnected = false;
    // console.log(this.currentClient.clienteID);
    this._cuestionarioServices.getResumenDesconexion(this._sidenav.currentDiag.diagnosticoID).subscribe( objTipoDesconexion => {
    this._cuestionarioServices.getDesconexion().subscribe( objDesconexion => {
      // console.log(objTipoDesconexion);
      objTipoDesconexion.forEach(element => {
        element.desconexion = objDesconexion.find( x => x.desconexionID === element.desconexionID);
        // console.log(element.desconexion);
        this._desconexiones.push(element);
        // Ordeno por como esta armado el canvas, primero superior en sentido del reloj
        //    Todo lo de afuera primero y despues lo de adentro. Comenzamos por el centro.
        if (element.desconexionID === 1) {
          this.isCenterDisconnected = true;
        }
        if (element.desconexionID === 3) { // Desconexion: Planes
          this.isfirstDisconnected = true; // Capa: Planes  Ubicacion: Superior Afuera
          this.isSuperiorDisconnected = true;
        }
        if (element.desconexionID === 9) { // Desconexion:Integracion Transversal
          this.issecondDisconnected = true; // Capa:  Integracion Transversal Ubicacion: Derecha Afuera
          this.isDerechoDisconnected = true;
        }
        if (element.desconexionID === 7) { // Desconexion: Comportamiento
          this.isthirdDisconnected = true; // Capa: Comportamiento Ubicacion: Abajo Afuera
          this.isInferiorDisconnected = true;
        }
        if (element.desconexionID === 4) { // Desconexion: Diseño Organizativo
          this.isfourthDisconnected = true; // Capa: Diseño Organizativo  Ubicacion: Izquierda afuera
          this.isIzquierdoDisconnected = true;
        }
        if (element.desconexionID === 2) { // Desconexion: Estrategia Valor
          this.isfifthDisconnected = true; //  Capa Estrategia Valor Ubicacion: Superior Adentro
          this.isSuperiorDisconnected = true;
        }
        if (element.desconexionID === 8) { // Desconexion: Proceso y tecnologia
          this.issixthDisconnected = true; // Capa: Proceso y tecnologia Ubicacion:  Derecha Adentro
          this.isDerechoDisconnected = true;
        }
        if (element.desconexionID === 6) { // Desconexion: Procesos- Creencia y supuestos
          this.isseventhDisconnected = true; // Capa: Creencia y supuestos  Ubicacion: Abajo Adentro
          this.isInferiorDisconnected = true;
        }
        if (element.desconexionID === 5) { // Desconexion: Capacidad
          this.iseighthDisconnected = true; // Capa: Capacidad  Ubicacion: Izquierda Adentro
          this.isIzquierdoDisconnected = true;
        }
        if (element.desconexionID === 10) { // Liderazgo
          this.isleadershipDisconnected = true;
        }
      }); });
    });
  }

  finalizar() {
   /* let  img: any;

    html2canvas(document.body).then(function (canvas: any) {
      // document.body.appendChild(canvas);
      img = canvas.toDataURL();
       console.log('img', img);
        // this.pdfwrapper.nativeElement.innerHTML;
  });
  this._sidenav.irFin(img);
  */
  this._sidenav.irFin(undefined);
  }
  Cancelar() {
    this._sidenav.Iniciar();
  }
  test(obj: MouseEvent) {
   // alert(obj.srcElement.innerHTML);
    alert(this.item);
  }
  showlikedisabled(evt: MouseEvent) {
    this.isShowlikedisabled = !this.isShowlikedisabled;
    evt.stopPropagation();
  }
  GetRespuestas(): Respuesta[] {
    if (this._respuestas !== undefined) {
    return this._respuestas.filter( a => a.respuestaTipoID === 1);
  }
}
GetCapa(id: number): string {
    if (this._capa !== undefined && this._capa.length > 0) {
      return this._capa.filter( a => a.capaId === id)[0].descripcion;
    } else {
      return '';
    }
}
isR(rp: Respuesta) {
  // console.log(rp.respuestaTipoOpcionID );
  return (rp.respuestaTipoOpcionID === 1 || rp.respuestaTipoOpcionID === 2 || rp.respuestaTipoOpcionID === 3 );
}
isY(rp: Respuesta) {
  return (rp.respuestaTipoOpcionID === 12 || rp.respuestaTipoOpcionID === 13);
}
isG(rp: Respuesta) {
  return (rp.respuestaTipoOpcionID === 14 || rp.respuestaTipoOpcionID === 15);
}

  setStyleRespuesta(rp: Respuesta, index: number) {
    // console.log(rp, index);
    const dimID = this._preguntas.filter(x => x.preguntasID === rp.preguntasID)[0].dimensionID;
    // console.log(dimID);
  /*  Aleatorio izq der, posicionado por dimension.
  let styles = {
      'top': ((dimID === 2 ? 100 : dimID === 5 ? 500 : 300) + (6 * this.randomInt(1, 10) * ((index % 2) === 0 ? 1 : -1))).toString() + 'px',
      'left': ((dimID === 3 ? 500 : dimID === 4 ? 100 : 300) + (6 * this.randomInt(1, 10) * ((index % 2) === 0 ? 1 : -1))).toString() + 'px'
    };*/
   // Ramdon de un array de posiciones
   let pos: Posicion;
   switch (dimID) {
    case 1:
      pos  = this._posicionesCentro[(index % 10)];
    break;
    case 2:
      pos  = this._posicionSuperior[(index % 10)];
    break;
    case 3:
      pos  = this._posicionDerecha[(index % 10)];
    break;
    case 4:
      pos  = this._posicionIzquierda[(index % 10)];
    break;
    case 5:
      pos  = this._posicionInferior[(index % 10)];
    break;
    case 6:
      pos  = this._posicionesAroExterior[(index % 10)];
    break;
    }
    const styles = {
      'top': pos.top + 'px',
      'left': pos.left + 'px',
    };
    // console.log(dimID, index, styles);
    return styles;
  }
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
 }
  Get(id: number): Pregunta {
    const preguntas: Pregunta[] = this._preguntas;
    const  index = preguntas.findIndex( (a) => a.preguntasID === id);
    if (index < 0) {
      return null;
    }
    return preguntas[index];
  }
  getDescripcion(id: number): string {
    return this.Get(id).descripcion;
  }
  getDimensionDescripcionbypg(pregunta_id: number): string {
    return this._dimensiones.filter(x => x.dimensionID === this.Get(pregunta_id).dimensionID)[0].descripcion;
  }
  getDimensionDescripcion(id: number): string {
    return this._dimensiones.filter(x => x.dimensionID === id)[0].descripcion;
  }
  getDimensionCapa(id: number): string {
    return this._capa.filter(x => x.capaId === id)[0].descripcion;
  }
  getLeyendaResumen(): string {
    let resumen = '';
    let dim = '';
    let carUnion = '';
    if (this._desconexiones.length > 0 && this._desconexiones[0].dimensionID !== null) {
      const diagDescripcion = this._sidenav.currentDiag.descripcion;
      if (this.currentClient !== null && this.currentClient !== undefined) {
      // if ( this._desconexiones.length === 1 ) {
      //    resumen = diagDescripcion + ' tiene una desconexión en ' + this._dimensiones[0].descripcion;
      // } else {
      if ( this._desconexiones.length > 1) {
        resumen = diagDescripcion + ' tiene desconexiones en ';
      } else {
        if ( this._desconexiones[0].dimensionID !== null) {
            resumen = diagDescripcion + ' tiene una desconexión en ';
          } else {
            resumen = diagDescripcion + ' esta en equilibrio. ';
          }
        }
      this._desconexiones.forEach((element, index) => {
        // console.log(element.dimensionID);
          const dimDesc = this._dimensiones.filter(x => x.dimensionID === element.dimensionID)[0].descripcion;
          if ( dim !== dimDesc) {
            resumen = resumen + carUnion + '"' + dimDesc + '"' ;
            if ( index === (this._desconexiones.length - 3)) { carUnion = ' y '; } else { carUnion = ', '; }
          }
          dim = dimDesc;
        });
      // }
      resumen = resumen + '.';
      }
    }
    // console.log(resumen);
    return resumen ;
  }
  GetRespuestaAsociada(preguntaID: number, deOption?: boolean): string {
    // console.log('Get Respuesta' , preguntaID);
    let respuestaValue = '';
    const resp = this.GetRespuesta(preguntaID);
    if (resp != null) {
      respuestaValue = this.GetRespuesta(preguntaID).valor;
    // console.log(respuestaValue);
    if (resp.respuestaTipoID !== undefined && resp.respuestaTipoID === 3) {
      if (deOption !== undefined && deOption	) {
        // Opcion De:.....
        respuestaValue = respuestaValue.substring(3, respuestaValue.indexOf('Hacia:') - 1 );
      } else {
        // Opcion Hacia :.....
        respuestaValue = respuestaValue.substring(respuestaValue.indexOf('Hacia:') + 6 );
      }
    }
    }
    return respuestaValue ;
  }
  GetRespuestaAsociadaId(preguntaID: number, deOption?: boolean): number {
    // console.log('Get Respuesta' , preguntaID);
    let respuestaValue = 0;
    const resp = this.GetRespuesta(preguntaID);
    if (resp != null) {
      respuestaValue = this.GetRespuesta(preguntaID).respuestaTipoOpcionID;
    // console.log(respuestaValue);
    }
    return respuestaValue ;
  }
  GetRespuesta(id: number): Respuesta {
    let result: Respuesta = null;
    if (this._respuestas != null) {
        // alert(id);
        const  index = this._respuestas.findIndex( (a) => a.preguntasID === id);
        // alert(index);
        if (index < 0) {
          result = null;
        }
        result = this._respuestas[index];
      }
      return result;
  }
  setRespuestaId(preguntaID: number,  id: number): void {
    // console.log('set', preguntaID, value );
    this.loaderService.display(true);
    const pr = this.Get(preguntaID);
    // console.log('respuesta tipo ', pr.respuestaTipoID );
    const ropt = this._respuestatipoopciones.filter(x => x.respuestaTipoOpcionID === id)[0];
    // console.log('respuesta opcion', ropt);
    let resp: Respuesta;
    if (this._respuestas != null) {
      const index = this._respuestas.findIndex(item => item.preguntasID === preguntaID);
      if (index > -1) {
        resp =  this._respuestas[index];
        resp.valor = ropt.respuestaOpcion;
        resp.respuestaTipoOpcionID = ropt.respuestaTipoOpcionID;
        this._cuestionarioServices.UpdateRespuesta(resp).subscribe(
          obj => {
            this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
              objRespuestas => {
                    this._respuestas = objRespuestas;
                    this.CalcularDesconexiones();
            });
          });
      } else {
        resp = new Respuesta(null,
          this.currentClient,
          this.currentClient.clienteID,
          pr.respuestaTipoID,
          ropt.respuestaTipoOpcionID,
          ropt,
          pr,
          pr.preguntasID,
          this._sidenav.currentEtapa,
          this._sidenav.currentEtapa.etapaId,
          this._sidenav.currentDiag.diagnosticoID,
          ropt.respuestaOpcion);
          this._cuestionarioServices.AddRespuesta(resp).subscribe(
              obj => {
                this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
                  objRespuestas => {
                        this._respuestas = objRespuestas;
                        this.CalcularDesconexiones();
                });
              });
          // this._respuestas.push(resp);
        }
    } else {
      resp = new Respuesta(null,
        this.currentClient,
        this.currentClient.clienteID,
        pr.respuestaTipoID,
        ropt.respuestaTipoOpcionID,
        ropt,
        pr,
        pr.preguntasID,
        this._sidenav.currentEtapa,
        this._sidenav.currentEtapa.etapaId,
        this._sidenav.currentDiag.diagnosticoID,
        ropt.respuestaOpcion);
        this._cuestionarioServices.AddRespuesta(resp).subscribe(
          obj => {
            this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
              objRespuestas => {
                    this._respuestas = objRespuestas;
                    this.CalcularDesconexiones();
            });
          });
        // this._respuestas.push(resp);
      }
      this.loaderService.display(false);
    }
 verVistaImpresion() {
    const dialogRef = this.dialog.open(SolucionDocumentComponent  );
    /*
    , {
        maxWidth: '100vw',
        maxHeight: '100vh',
       }
   */
 }
 verVistaCompleta(titulo, resumen, desco, dimID) {
  console.log(dimID);
  const dialogConfig = new MatDialogConfig();
  dialogConfig.data = { titulo: titulo,
                        resumen: resumen ,
                        desconexion: desco ,
                        dimID};
  // dialogConfig.maxHeight = '200vh';
  // dialogConfig.maxWidth = '100vw';
  const dialogRef = this.dialog.open(TarjetacompletaComponent , dialogConfig );
  /*
  , {
      maxWidth: '100vw',
      maxHeight: '100vh',
     }
 */
}
}
/*
       <h3> {{this.getLeyendaResumen()}}</h3>
       <div class="disconnection-description" *ngFor="let desco of this._desconexiones; let iDesco= index; let first = first">
            <h3> {{(first)?
                      ((desco.dimensionID !== null)? 'En la dimensión "' + getDimensionDescripcion(desco.dimensionID) +'"' : desco.titulo)
                          : ((desco.dimensionID !== null)? (desco.dimensionID === this._desconexiones[iDesco-1].dimensionID)?
                           'En la misma dimensión'
                              : 'En la dimensión "' + getDimensionDescripcion(desco.dimensionID) +'"' :'') }}
                {{(desco.capaId !== null)? ',  la desconexión se da en la capa "' + getDimensionCapa(desco.capaId) +'"':''}}
            </h3>
            <div style="text-align:justify">
                {{desco.desconexion.resumen}}. <br>
                <a (click)="(itemDesco === 99 )?itemDesco = iDesco:itemDesco = 99;" > {{((itemDesco === iDesco)?
                   'Ver menos...' : 'Ver mas...' )}} </a>
                <div *ngIf="itemDesco === iDesco" [innerHTML]="desco.desconexion.descripcion" ></div>
            </div>

        </div>
*/



// WEBPACK FOOTER //
// ./src/app/solucion/solucion.component.ts